import React from 'react';
import { connect } from 'react-redux';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';

import AppointmentBox from '../../../components/AppointmentBox/AppointmentBox';

import classes from './Appointments.css';

class Appointments extends React.Component{

    render(){

        let content;
        if (this.props.appointments === undefined || this.props.appointments.length <= 0){
            content = <Col> You currently do not have any appointment </Col>
        }
        else {
            content = 
                this.props.appointments.map((appointment, index) => (

                    <Col lg={4} key={index}>
                    <AppointmentBox 
                        appointment_id={appointment.id}
                        firstName={appointment.first_name}
                        lastName={appointment.last_name}
                        email={appointment.email} 
                        id={appointment.id}
                        info={appointment.info} 
                        time={appointment.due_date}
                        role={appointment.role}
                        host={appointment.host}
                        guest={appointment.guest}
                        contact_method={appointment.contact_method}
                        key={index}
                        isMobile={this.props.isMobile}>
                    </AppointmentBox>
                    </Col>
                ));
        }

        return (
            <Container>
            <Card bsPrefix={classes.CardBody}>
            <Card.Header><b>Appointments</b></Card.Header>
            <Card.Body>
                <Row>
                    { content }
                </Row>
            </Card.Body>
            </Card>
          </Container>
        );
    }
}

// export default Appointment;
const mapStateToProps = state => {
    return {
        appointments: state.appointment.appointments,
    };
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

export default connect( mapStateToProps, mapDispatchToProps ) (Appointments);


// WEBPACK FOOTER //
// ./src/containers/Profile/Appointments/Appointments.js